import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from '../../util/reactIntl';
import { ResponsiveImage, Modal, PrimaryButtonInline } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import ActionBarMaybe from './ActionBarMaybe';

import css from './ListingPage.module.css';

const SectionHero = props => {
  const {
    title,
    listing,
    isOwnListing,
    editParams,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    noPayoutDetailsSetWithOwnListing,
    onCloseListing,
    onOpenListing,
    openingListing,
    closingListing,
  } = props;

  const hasImages = listing.images && listing.images.length > 0;
  const firstImage = hasImages ? listing.images[0] : null;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];

  const viewPhotosButton = hasImages ? (
    <button className={css.viewPhotos} onClick={handleViewPhotosClick}>
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: listing.images.length }}
      />
    </button>
  ) : null;

  const isClosed = listing.attributes.state === 'CLOSED';

  return (
    <section className={css.sectionHero} data-testid="hero">
      <div className={css.imageWrapperForSectionHero} onClick={handleViewPhotosClick}>
        {listing.id && isOwnListing ? (
          <div onClick={e => e.stopPropagation()} className={css.actionBarContainerForHeroLayout}>
            {noPayoutDetailsSetWithOwnListing ? (
              <ActionBarMaybe
                className={css.actionBarForHeroLayout}
                isOwnListing={isOwnListing}
                listing={listing}
                showNoPayoutDetailsSet={noPayoutDetailsSetWithOwnListing}
                onCloseListing={onCloseListing}
                onOpenListing={onOpenListing}
                actionsInProgressListingId={openingListing || closingListing}
              />
            ) : null}

            <ActionBarMaybe
              className={css.actionBarForHeroLayout}
              isOwnListing={isOwnListing}
              listing={listing}
              editParams={editParams}
              onCloseListing={onCloseListing}
              onOpenListing={onOpenListing}
              actionsInProgressListingId={openingListing || closingListing}
            />
          </div>
        ) : null}

        <ResponsiveImage
          rootClassName={css.rootForImage}
          alt={title}
          image={firstImage}
          variants={variants}
        />
        {viewPhotosButton}

        {isClosed && (
          <div className={css.openListingButtonContainer}>
            <PrimaryButtonInline
              className={css.openListingButton}
              disabled={!!actionsInProgressListingId}
              onClick={() => {
                if (!actionsInProgressListingId) {
                  onOpenListing(listing.id);
                }
              }}
            >
              <FormattedMessage id="ManageListingCard.openListing" />
            </PrimaryButtonInline>
          </div>
        )}
      </div>
      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={listing.images}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>
    </section>
  );
};

SectionHero.propTypes = {
  title: PropTypes.string.isRequired,
  listing: PropTypes.object.isRequired,
  isOwnListing: PropTypes.bool.isRequired,
  editParams: PropTypes.shape({
    id: PropTypes.string,
    slug: PropTypes.string,
    type: PropTypes.string,
    tab: PropTypes.string,
  }),
  handleViewPhotosClick: PropTypes.func.isRequired,
  imageCarouselOpen: PropTypes.bool.isRequired,
  onImageCarouselClose: PropTypes.func.isRequired,
  onManageDisableScrolling: PropTypes.func.isRequired,
  noPayoutDetailsSetWithOwnListing: PropTypes.bool.isRequired,
  onCloseListing: PropTypes.func.isRequired,
  onOpenListing: PropTypes.func.isRequired,
  actionsInProgressListingId: shape({ uuid: string.isRequired }),
  closingListing: shape({ uuid: string.isRequired }),
  openingListing: shape({ uuid: string.isRequired }),
};

export default SectionHero;
